import { Box, Typography, useTheme } from '@mui/material';
import { JsonViewer } from '@textea/json-viewer';
import React from 'react';
import { ITheme } from 'types/theme';

interface IAuditCardDataValueProps {
	value: Record<string, unknown>;
}

const AuditCardDataValue: React.FC<IAuditCardDataValueProps> = ({ value }) => {
	const theme = useTheme<ITheme>();
	return (
		<Box
			data-testid="audit-card-item-data"
			sx={{
				maxHeight: '200px',
				overflow: 'scroll'
			}}
		>
			<Typography variant="subtitle2">
				<JsonViewer
					value={value}
					enableClipboard={false}
					displayDataTypes={false}
					quotesOnKeys={false}
					theme={theme.palette.mode}
					style={{
						padding: 4,
						backgroundColor: theme.palette.multiline.background
					}}
				/>
			</Typography>
		</Box>
	);
};

export default AuditCardDataValue;
